var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from "@animech/ui";
import { useTranslation } from "react-i18next";
import { CustomConfirmModal } from "ui/components/modals/custom-confirm-modal/custom-confirm-modal";
export var SaveSystemConfirmationModal = function (_a) {
    var props = __rest(_a, []);
    var systemName = props.systemName;
    var t = useTranslation().t;
    var translate = function (key) {
        return t("save_system_confirm_modal.".concat(key));
    };
    return (_jsx(CustomConfirmModal, __assign({ title: t("save_system_confirm_modal.title", {
            systemName: systemName,
        }), cancelActionLabel: t("modal.close"), okActionLabel: translate("confirm_button"), color: "inverted", cancelButtonProps: { color: "primary" }, confirmButtonProps: {
            color: "primary",
        }, hideCloseButton: false }, props, { children: _jsx(Container, { children: translate("text") }) })));
};
